/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DDay} from "../DDay";
import {TimelineLite} from "gsap";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BlitzKriegSymbolState} from "../symbol/DDaySymbolConfig";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Layers} from "../view/DDayLayers";
import {BlitzKriegGameMode} from "../server/BlitzKriegGameMode";
import {GameHelper} from "../../core/utils/GameHelper";
import {BlitzKriegParsedGameData} from "../server/data/BlitzKriegParsedGameData";
import {BlitzKriegParsedInitData} from "../server/data/BlitzKriegParsedInitData";

export class BlitzKriegNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay: number = 0.06;
    private _fastStartDelay: number = 0.01;

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        DDay.initialCountUp.remove();
        DDay.bigWinCountUp.remove();
        DDay.backgroundView.resetTextEffect();
        let layers: StageLayer | undefined = NolimitApplication.getLayerByName(Layers.FOREGROUND_ANIMATION);
        let length: number | undefined = layers?.children.length;
        let tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                layers?.removeChildren(0);
            }
        });
        if (length) {
            layers?.children.forEach((child) => {
                tl.to(child, {
                    alpha: 0,
                    duration: 0.2
                }, 0)
            });
        }
        BlitzKriegSound.playTrack({name: BlitzKriegSound.REELS_SPINNING});
        const promises: Promise<any>[] = [];
        DDay.reelBackground.setXWaysCount(720);
        DDay.reelStartPresentations.start();
        DDay.reelBackground.enableDisableEasterEgg(true);
        DDay.reelBackground.playRadioIdleAnimation();

        DDay.reels.forEach((reel, reelId) => {
            reel.reelView.allSymbols.forEach((symbol) => {
                symbol.getStateAnimation(BlitzKriegSymbolState.NORMAL, {duration: 0, alpha: 1}, {duration: 0}).play();
            });
            promises.push(reel.startSpin(true, (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay)));
        });

        Promise.all(promises).then(res => flowStateController.finish());
    }
}
